export default {"src":"/_next/static/media/SWI.2d4fde69.svg","height":18,"width":18};